import { FiMaximize2 as _FiMaximize } from "@react-icons/all-files/fi/FiMaximize2.js";
import _styled from "styled-components";
import React from 'react';
import { observer } from 'mobx-react';
import { Box, Button, Divider, Flex, Icon, LinkButton, Tag, Text } from 'core/components';
import { CLOUD_PROVIDERS } from 'app/util/constants';
function Row({
  label,
  value
}) {
  if (value == null || value === '' || value === '---') {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    mb: "6px"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "div",
    small: true,
    fontWeight: "bold"
  }, label), /*#__PURE__*/React.createElement(Text, {
    as: "div",
    small: true,
    muted: true,
    style: {
      wordBreak: 'break-word'
    }
  }, value));
}

/** Compact agent summary shown in the AgentDisplay hover popover (site / labels / ASN / IPs). */
const AgentPopoverCard = observer(({
  agent,
  onOpenDetails,
  fullPageHref
}) => {
  if (!agent) {
    return null;
  }
  const AgentIcon = agent.icon;
  const provider = agent.get('metadata.cloud_provider');
  const cloudLogo = provider ? CLOUD_PROVIDERS.byId(provider).logo : null;
  const labels = agent.labels || [];
  const asn = agent.get('asn');
  const asnText = asn && String(asn) !== '0' ? agent.asFormatted : null;
  const site = agent.siteDisplayName;
  const cloudRegion = provider ? agent.cloudRegion : null;
  const location = agent.locationString;
  const publicIps = [agent.get('metadata.public_ipv4_addresses[0].value') || agent.get('ip'), agent.get('metadata.public_ipv6_addresses[0].value')].filter(Boolean).join(', ');
  const privateIps = [agent.get('metadata.private_ipv4_addresses[0].value') || agent.get('local_ip'), agent.get('metadata.private_ipv6_addresses[0].value')].filter(Boolean).join(', ');
  const status = agent.status;
  return /*#__PURE__*/React.createElement(Box, {
    p: 2,
    minWidth: 240,
    maxWidth: 320
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    mb: 1
  }, cloudLogo ? /*#__PURE__*/React.createElement(_StyledFlex, {
    mr: "6px"
  }, cloudLogo) : AgentIcon && /*#__PURE__*/React.createElement(Box, {
    mr: "6px"
  }, /*#__PURE__*/React.createElement(AgentIcon, {
    width: 16,
    height: 16
  })), /*#__PURE__*/React.createElement(Text, {
    fontWeight: "bold",
    ellipsis: true
  }, agent.label), status?.icon && /*#__PURE__*/React.createElement(Icon, {
    ml: "auto",
    pl: "6px",
    icon: status.icon,
    color: status.color,
    title: status.text,
    iconSize: 12
  })), labels.length > 0 && /*#__PURE__*/React.createElement(Flex, {
    flexWrap: "wrap",
    gap: "4px",
    mb: "8px"
  }, labels.map(label => /*#__PURE__*/React.createElement(Tag, {
    key: label.id,
    small: true,
    minimal: true,
    bg: label.get('color') || '#888',
    color: "#ffffff"
  }, label.get('name')))), /*#__PURE__*/React.createElement(Row, {
    label: "Site",
    value: site
  }), /*#__PURE__*/React.createElement(Row, {
    label: "ASN",
    value: asnText
  }), /*#__PURE__*/React.createElement(Row, {
    label: provider ? 'Cloud Region' : 'Location',
    value: cloudRegion && cloudRegion !== '---' ? cloudRegion : location
  }), /*#__PURE__*/React.createElement(Row, {
    label: "Public IP",
    value: publicIps
  }), /*#__PURE__*/React.createElement(Row, {
    label: "Private IP",
    value: privateIps
  }), onOpenDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    my: 1
  }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Button, {
    small: true,
    minimal: true,
    intent: "primary",
    icon: "maximize",
    onClick: e => {
      // Popover content is portaled but still bubbles through the React tree to the
      // legend row's click handler; stop it so opening details doesn't toggle the series.
      e.stopPropagation();
      onOpenDetails();
    }
  }, "Open details")), !onOpenDetails && fullPageHref && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    my: 1
  }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement("div", {
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/React.createElement(LinkButton, {
    small: true,
    minimal: true,
    intent: "primary",
    icon: _FiMaximize,
    to: fullPageHref
  }, "Open Full Page"))));
});
export default AgentPopoverCard;
var _StyledFlex = _styled(Flex).withConfig({
  displayName: "AgentPopoverCard___StyledFlex",
  componentId: "sc-1dhvsj-0"
})({
  '& svg': {
    height: '16px',
    width: 'auto'
  }
});